<template>
  <div class="g-container">
    <cmp-header></cmp-header>
    <cmpBread v-if="!$route.meta.hideBread"></cmpBread>

    <!-- <keep-alive v-if="isKeepAlive" :include="cachedViews">
      <router-view :key="key" />
    </keep-alive> -->

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <cmpFooter></cmpFooter>
  </div>
</template>

<script>
import cmpHeader from '@cmp/header/index'
import cmpFooter from '@cmp/footer'
export default {
  components: {
    cmpHeader,
    cmpFooter
  },
  data() {
    return {
      // 刷新缓存
      isKeepAlive: true
    }
  },
  provide() {
    return {
      reload: this.reload // 其他页面调用此方法可清除keep-alive缓存
    }
  },
  methods: {
    reload() {
      this.isKeepAlive = false
      this.$nextTick(() => {
        this.isKeepAlive = true
      })
    }
  },
  computed: {
    cachedViews() {
      return this.$store.state.app.cachedViews
    },

    key() {
      return this.$route.path
    }
  }
}
</script>